<template>
  <v-container fluid class="pa-0">
    <v-list light :color="appColor_PanelBackgroundLight">
      <v-list v-for="(filter, i) in optionalFilters" :key="i">
        <user-filter v-bind:filter="filter" />
      </v-list>
    </v-list>
  </v-container>
</template>

<script>
import UserFilter from '@/components/UserFilter'
import { AppColor } from '@/config.js'

export default {
  name: "UserFilterList",
  components: {
    UserFilter
  },
  props: {
    optionalFilters: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    appColor_PanelBackgroundLight: AppColor.PanelBackgroundLight
  })
}
</script>

